import moment from 'moment';
import React from 'react';
import './report.css';
import logo from './MP_02.png';
function getMoment(date = new Date(), tz = 'Asia/Singapore') {
  return moment(date).tz(tz);
}

export const Header = () => {
  return (
    <div className="header">
      <img src={logo} style={{ width: 200, height: 30 }} />
      <p
        style={{
          fontSize: '24px',
          fontWeight: 'bold',
          lineHeight: 1.5,
          marginBottom: '10px',
          color: 'white',
        }}
      >
        {getMoment(new Date()).format('DD MMM YYYY')}
      </p>
    </div>
  );
};

const Footer = (props) => {
  return (
    <div className="footer">
      <div style={{ marginBottom: '20px' }}>
        <span>Generated by: {props.username}</span>
      </div>
      <div style={{ marginBottom: '20px' }}>
        <span>page {props.page || 1}</span>
      </div>
    </div>
  );
};

export const RepresentativesUsage = (props) => {
  return (
    <div className="page">
      <Header />
      <Footer page={props.page} username={props.user.username} />
      <div className="p-4">
        <span style={{ fontSize: '24px', color: 'blue', fontWeight: 'bold' }}>
          Polls & Representatives Usage
        </span>
        <div className="mt-3 w-full flex">
          <div className="w-1/2">
            <span
              style={{
                fontSize: '20px',
                color: 'blue',
                fontWeight: 'bold',
              }}
            >
              Representatives
            </span>
            <p
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            >
              {props.repLength}
            </p>
          </div>

          <div className="w-1/2">
            <span
              style={{
                fontSize: '20px',
                color: 'blue',
                fontWeight: 'bold',
              }}
            >
              Polls/pledges created
            </span>
            <p
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            >
              25
            </p>
          </div>
        </div>
      </div>
      <div
        className="my-3"
        style={{ width: '100%', height: '1px', background: '#ff46ff' }}
      ></div>
      <div className="p-4">
        <span
          style={{
            fontSize: '20px',
            color: 'blue',
            fontWeight: 'bold',
          }}
        >
          Representatives
        </span>

        {props.array.map((item, index) => (
          <p
            key={'abc-' + index}
            style={{
              fontSize: '20px',
              fontWeight: 'bold',
            }}
          >
            {item}
          </p>
        ))}
      </div>
    </div>
  );
};

export const ProxiesUsage = (props) => {
  return (
    <div className="page">
      <Header />
      <Footer page={props.page} username={props.user.username} />
      <div className="p-4">
        <span style={{ fontSize: '24px', color: 'blue', fontWeight: 'bold' }}>
          Polls & Proxies Usage
        </span>
        <div className="mt-3 w-full flex">
          <div className="w-1/2">
            <span
              style={{
                fontSize: '20px',
                color: 'blue',
                fontWeight: 'bold',
              }}
            >
              Proxy
            </span>
            <p
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            >
              {props.proLength}
            </p>
          </div>

          <div className="w-1/2">
            <span
              style={{
                fontSize: '20px',
                color: 'blue',
                fontWeight: 'bold',
              }}
            >
              Polls/pledges created
            </span>
            <p
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            >
              25
            </p>
          </div>
        </div>
        <div>
          <span
            style={{
              fontSize: '20px',
              color: 'blue',
              fontWeight: 'bold',
            }}
          >
            Polls/pledges voted with proxy
          </span>
          <p
            style={{
              fontSize: '20px',
              fontWeight: 'bold',
            }}
          >
            20
          </p>
        </div>
      </div>
      <div
        className="my-3"
        style={{ width: '100%', height: '1px', background: '#ff46ff' }}
      ></div>
      <div className="p-4">
        <span
          style={{
            fontSize: '20px',
            color: 'blue',
          }}
        >
          Proxy
        </span>

        {props.array.map((item, index) => (
          <p
            key={'proxies-' + index}
            style={{
              fontSize: '20px',
              fontWeight: 'bold',
            }}
          >
            {item}
          </p>
        ))}
      </div>
    </div>
  );
};

export const Company = ({ page, data, user }) => {
  return (
    <div className="page">
      <Header />
      <Footer page={page} username={user.username} />
      <div style={{ padding: '0 20px' }}>
        <span
          style={{
            fontSize: '24px',
          }}
        >
          Information Report for
        </span>
        <p style={{ fontSize: '20px' }}>{data.company.name}</p>
        <span
          className="mt-3"
          style={{
            fontSize: '20px',
            color: 'blue',
          }}
        >
          Subscription
        </span>
        <div className="w-full flex">
          <div className="w-1/2">
            <span
              style={{
                fontSize: '20px',
                color: 'blue',
                fontWeight: 'bold',
              }}
            >
              Start Date
            </span>
            <p
              style={{
                fontSize: '20px',
              }}
            >
              {data.subscriptionData?.start}
            </p>
          </div>

          <div className="w-1/2">
            <span
              style={{
                fontSize: '20px',
                color: 'blue',
                fontWeight: 'bold',
              }}
            >
              End Date
            </span>
            <p
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            >
              {data.subscriptionData?.end}
            </p>
          </div>
        </div>
        <div
          className="my-3"
          style={{ width: '100%', height: '1px', background: '#ff46ff' }}
        ></div>
        <span
          style={{
            fontSize: '20px',
            color: 'blue',
            fontWeight: 'bold',
          }}
        >
          Polls
        </span>
        <div className="mt-3 w-full">
          <span
            style={{
              fontSize: '20px',
              color: 'blue',
              fontWeight: 'bold',
            }}
          >
            Utilized
          </span>
          <p
            style={{
              fontSize: '20px',
              fontWeight: 'bold',
            }}
          >
            {data.pollsData.total}{' '}
            <span style={{ marginLeft: 20, color: 'blue' }}>
              / {data.pollsData.maximum}
            </span>
          </p>
        </div>
        <div className="mt-16 w-full flex">
          <div className="w-1/2">
            <span
              style={{
                fontSize: '20px',
                color: 'blue',
                fontWeight: 'bold',
              }}
            >
              Polls
            </span>
            <p
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            >
              {data.pollsData.pollWithoutPledge}
            </p>
          </div>

          <div className="w-1/2">
            <span
              style={{
                fontSize: '20px',
                color: 'blue',
                fontWeight: 'bold',
              }}
            >
              Polls w/ Pledge
            </span>
            <p
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            >
              {data.pollsData.pollWithPledge}
            </p>
          </div>
        </div>
        <div className="mt-16 w-full flex">
          <div className="w-1/3">
            <span
              style={{
                fontSize: '20px',
                color: 'blue',
                fontWeight: 'bold',
              }}
            >
              Open
            </span>
            <p
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            >
              {data.pollsData.open}
            </p>
          </div>

          <div className="w-1/3">
            <span
              style={{
                fontSize: '20px',
                color: 'blue',
                fontWeight: 'bold',
              }}
            >
              Closed
            </span>
            <p
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            >
              {data.pollsData.close}
            </p>
          </div>
          <div className="w-1/3">
            <span
              style={{
                fontSize: '20px',
                color: 'blue',
                fontWeight: 'bold',
              }}
            >
              Delete
            </span>
            <p
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            >
              {data.pollsData.deleted}
            </p>
          </div>
        </div>
        <div className="mt-16 w-full flex">
          <div className="w-1/2">
            <span
              style={{
                fontSize: '20px',
                color: 'blue',
                fontWeight: 'bold',
              }}
            >
              Polls w/ Pledge
            </span>
            <p
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            >
              {data.pollsData.pollWithPledge}
            </p>
          </div>

          <div className="w-1/2">
            <span
              style={{
                fontSize: '20px',
                color: 'blue',
                fontWeight: 'bold',
              }}
            >
              Total Pledge Amount
            </span>
            <p
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            >
              $ {data.pollsData.totalPledgeAmount}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export const RecordPage = (props) => {
  return (
    <div className="page">
      <Header />
      <Footer page={props.page} username={props.user.username} />
      {props.array.map((item, index) => (
        <div className="mt-3 px-4">
          <span
            style={{
              fontSize: '20px',
              color: 'blue',
              fontWeight: 'bold',
            }}
          >
            {' '}
            {item.name}
          </span>
          {item.array.map((record, i) => (
            <p
              key={'recordpage-' + i}
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            >
              {record}
            </p>
          ))}
        </div>
      ))}
    </div>
  );
};

export const UserInfo = ({ userInfoViews, page, lengData, user }) => {
  return (
    <div className="page">
      <Header />
      <Footer page={page} username={user.username} />

      <div className="w-full px-4">
        <span
          style={{
            fontSize: '24px',
            color: 'blue',
            fontWeight: 'bold',
          }}
        >
          {' '}
          User Information
        </span>
        <div className="mt-3 w-full flex">
          <div className="w-1/2">
            <span
              style={{
                fontSize: '20px',
                color: 'blue',
                fontWeight: 'bold',
              }}
            >
              Representatives
            </span>
            <p
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            >
              {lengData.repData.length}
            </p>
          </div>

          <div className="w-1/2">
            <span
              style={{
                fontSize: '20px',
                color: 'blue',
                fontWeight: 'bold',
              }}
            >
              Number of Proxies
            </span>
            <p
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            >
              {lengData.proData.length}
            </p>
          </div>
        </div>
        <div className="mt-5">
          <span
            style={{
              fontSize: '20px',
              color: 'blue',
              fontWeight: 'bold',
            }}
          >
            Number of Users
          </span>
          <p
            style={{
              fontSize: '20px',
              fontWeight: 'bold',
            }}
          >
            {lengData.uData.length}
          </p>
        </div>
      </div>
      <div
        className="my-3"
        style={{ width: '100%', height: '1px', background: '#ff46ff' }}
      ></div>
      <div className="w-full px-4">
        {userInfoViews.map((item, index) => (
          <div className="mt-3" key={'type' + index}>
            <span
              style={{
                fontSize: '20px',
                color: 'blue',
                fontWeight: 'bold',
              }}
            >
              {' '}
              {item.name}
            </span>
            {item.array.map((record, i) => (
              <p
                key={'record-' + i}
                className="mt-2"
                style={{
                  fontSize: '20px',
                  fontWeight: 'bold',
                }}
              >
                {record}
              </p>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export const PollInfo = ({ data, page, pollsData, user }) => {
  return (
    <div className="page">
      <Header />
      <Footer page={page} username={user.username} />
      <div style={{ padding: '0 20px' }}>
        <span style={{ fontSize: '24px', color: 'blue', fontWeight: 'bold' }}>
          Poll Information
        </span>
        <div className="mt-3 w-full">
          <span
            style={{
              fontSize: '20px',
              color: 'blue',
              fontWeight: 'bold',
            }}
          >
            Polls Created
          </span>
          <p
            style={{
              fontSize: '20px',
              fontWeight: 'bold',
            }}
          >
            {pollsData.total}{' '}
            <span style={{ marginLeft: 20, color: 'blue' }}>
              /{pollsData.maximum}
            </span>
          </p>
        </div>

        <div className="mt-3 w-full flex">
          <div className="w-1/2">
            <span
              style={{
                fontSize: '20px',
                color: 'blue',
                fontWeight: 'bold',
              }}
            >
              Polls
            </span>
            <p
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            >
              {pollsData.pollWithoutPledge}
            </p>
          </div>

          <div className="w-1/2">
            <span
              style={{
                fontSize: '20px',
                color: 'blue',
                fontWeight: 'bold',
              }}
            >
              Polls w/ Pledge
            </span>
            <p
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            >
              {pollsData.pollWithPledge}
            </p>
          </div>
        </div>
        <div className="mt-3 w-full flex">
          <div className="w-1/3">
            <span
              style={{
                fontSize: '20px',
                color: 'blue',
                fontWeight: 'bold',
              }}
            >
              Open
            </span>
            <p
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            >
              {pollsData.open}
            </p>
          </div>

          <div className="w-1/3">
            <span
              style={{
                fontSize: '20px',
                color: 'blue',
                fontWeight: 'bold',
              }}
            >
              Closed
            </span>
            <p
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            >
              {pollsData.close}
            </p>
          </div>
          <div className="w-1/3">
            <span
              style={{
                fontSize: '20px',
                color: 'blue',
                fontWeight: 'bold',
              }}
            >
              Delete
            </span>
            <p
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            >
              {pollsData.deleted}
            </p>
          </div>
        </div>
      </div>
      <div
        className="my-3"
        style={{ width: '100%', height: '1px', background: '#ff46ff' }}
      ></div>
      <div className="p-4">
        <table style={{ width: '100%' }}>
          <tr>
            <th style={{ width: '40%' }}>Poll title</th>
            <th style={{ width: '22%' }}>StartDate/ Time</th>
            <th style={{ width: '22%' }}>End Date/ Time</th>
            <th style={{ width: '16%' }}>Status</th>
          </tr>
          {data?.map((item, index) => (
            <tr key={'table-' + index}>
              <td>{item.title}</td>
              <td>
                {item.startDate.toDateString() +
                  ' ' +
                  item.startDate.getHours() +
                  ':' +
                  item.startDate.getMinutes() +
                  ':' +
                  item.startDate.getSeconds()}
              </td>
              <td>
                {item.endDate.toDateString() +
                  ' ' +
                  item.endDate.getHours() +
                  ':' +
                  item.endDate.getMinutes() +
                  ':' +
                  item.endDate.getSeconds()}
              </td>
              <td>{item.status}</td>
            </tr>
          ))}
        </table>
      </div>
    </div>
  );
};

export const PollTable = ({ data, page, user }) => {
  return (
    <div className="page">
      <Header />
      <Footer page={page} username={user.username} />
      <div className="p-4">
        <table style={{ width: '100%' }}>
          <tr>
            <th style={{ width: '40%' }}>Poll title</th>
            <th style={{ width: '22%' }}>StartDate/ Time</th>
            <th style={{ width: '22%' }}>End Date/ Time</th>
            <th style={{ width: '16%' }}>Status</th>
          </tr>
          {data?.map((item, index) => (
            <tr key={'table-' + index}>
              <td>{item.title}</td>
              <td>{item.startDate.toDateString()}</td>
              <td>{item.endDate.toDateString()}</td>
              <td>{item.status}</td>
            </tr>
          ))}
        </table>
      </div>
    </div>
  );
};
